import { render, staticRenderFns } from "./main-coverage.vue?vue&type=template&id=24bcfbfe&"
import script from "./main-coverage.vue?vue&type=script&lang=js&"
export * from "./main-coverage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports